import { RolAutoridad } from '@/shared/model/enumerations/rol-autoridad.model';

export interface IPersonalBeca {
  cvu?: string | null;
  usuario?: string | null;
  nombreCompleto?: string | null;
  rol?: RolAutoridad | null;
  area?: string | null;
  programaClaves?: string[] | null;
  institucionClaves?: string[] | null;
  sedeClaves?: string[] | null;
  comisionesClaves?: string[] | null;
}

export class PersonalBeca implements IPersonalBeca {
  constructor(
    public cvu?: string | null,
    public usuario?: string | null,
    public nombreCompleto?: string | null,
    public rol?: RolAutoridad | null,
    public area?: string | null,
    public programaClaves?: string[] | null,
    public institucionClaves?: string[] | null,
    public sedeClaves?: string[] | null,
    public comisionesClaves?: string[] | null
  ) {}

  static fromObject(data: IPersonalBeca): PersonalBeca {
    const personalBeca = new PersonalBeca();
    for (const [key, value] of Object.entries(data)) {
      personalBeca[key] = value;
    }
    return personalBeca;
  }

  fromObject(data: IPersonalBeca): void {
    for (const [key, value] of Object.entries(data)) {
      this[key] = value;
    }
  }
}
